import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";

import { KeyValue } from "@/main/models/common";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from "@/main/services/utils";
import { getInsurers, resetReducerInsurers, useInsurerReducer } from "@/main/store/insurer";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";

export const INITIAL_FORM_STATE_INSURER = {
	insurer: null as KeyValue | null,
};

export type IFormFiltersMappingTypeInsurer = typeof INITIAL_FORM_STATE_INSURER;

interface IFiltersMappingTypeInsurerProps {}
function FiltersMappingTypeInsurer(_props: IFiltersMappingTypeInsurerProps) {
	const dispatch = useDispatch();
	const { watcherCountry, keyReducer, isRequiredField } = useDinamicFiltersMappingCodes();
	const { isolated: insurersReducer } = useInsurerReducer(keyReducer);

	const { control, resetField, setValue } = useFormContext<IFormFiltersMappingTypeInsurer>();

	useEffect(() => {
		if (!isValueQueryParams(watcherCountry)) {
			resetField("insurer");
		}
		if (isNullUndefined(watcherCountry)) return;

		dispatch(
			getInsurers(
				{
					guidCountry: String(watcherCountry.key),
					idStatusRegister: StatusRegisterEnum.Active,
				},
				keyReducer,
			),
		);

		return () => {
			dispatch(resetReducerInsurers());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledInsurer = isNullUndefined(insurersReducer.data) || insurersReducer.data.length === 1;

	return (
		<>
			<KogAutoCompleteControlled
				id="id-mappingCode-select-insurer"
				nameCustom="insurer"
				label={getTranslateByKey("information.insurer")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={insurersReducer.data}
				isLoading={insurersReducer.isLoading}
				disabled={disabledInsurer}
				rulesCustom={{ required: isRequiredField("insurer") }}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default FiltersMappingTypeInsurer;
